<template>
  <div>
    
  </div>
</template>

<script>
export default {
  created() {
    window.location.href = "https://www.itdks.com/mobile/user"
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Mine/Mine.vue